import styled from '@emotion/styled';
import { motion } from 'framer-motion';
import { type OmitFramerProps, type HTMLDivProps } from '@/lib/types';

type ChallengeContentOuterWrapperProps = OmitFramerProps<HTMLDivProps> & {
  hidden?: boolean;
};

const StyledWrapper = styled(motion.section)<ChallengeContentOuterWrapperProps>(
  ({ hidden }) => ({
    width: '100%',
    overflowY: 'auto',
    display: hidden ? 'none' : undefined,
  }),
);

const ChallengeContentOuterWrapper = ({
  hidden,
  ...props
}: ChallengeContentOuterWrapperProps) => (
  <StyledWrapper
    initial={{
      y: 10,
      opacity: 0,
    }}
    animate={{
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.1,
        delay: 0.15,
      },
    }}
    hidden={hidden}
    {...props}
  />
);

export default ChallengeContentOuterWrapper;
